import React from "react";
import ClaimMultiSelect from "./claimSearchableMultiSelect";
import type { CodeOption } from "./claimSearchableMultiSelect";

export interface ClaimCodeMultiSelectProps {
  fetchOptions: (
    searchTerm: string,
    page: number,
    pageSize: number
  ) => Promise<{ data: CodeOption[]; total: number }>;

  value: CodeOption[];
  onChange: (values: CodeOption[]) => void;

  placeholder?: string;
  disabled?: boolean;
  minChars?: number; 
}

const ClaimCodeMultiSelect: React.FC<ClaimCodeMultiSelectProps> = ({
  fetchOptions,
  value,
  onChange,
  placeholder = "Search and select codes...",
  disabled = false,
  minChars = 3, 
}) => {
  return (
    <div data-testid="ClaimCodeMultiSelect-container" style={{ width: "100%" }}>
      <ClaimMultiSelect
        data-testid="ClaimCodeMultiSelect-select"
        fetchOptions={fetchOptions}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        minChars={minChars} 
        style={{ width: "100%", marginBottom: 5 }}
      />
    </div>
  );
};

export default ClaimCodeMultiSelect;